import Api from '@sancare/typescript-commons/src/misc/api'

import { state } from '@/store/modules/diagnosis/smr/state'
import { DiagnosisType } from '@/store/modules/diagnosis/types'
import { PayloadWithMut } from '@/store/types'

interface SmrDiagnosisPayload extends PayloadWithMut {
  urlParams : {
    rhsId: number
  }
}

interface AddSmrDiagnosisPayload extends SmrDiagnosisPayload {
  body: {
    newDiagnosisType: DiagnosisType
    diagnosis: string
  }
}

interface RemoveSmrDiagnosisPayload extends SmrDiagnosisPayload {
  urlParams : {
    rhsId: number
    associatedDiagnosisId: number
  }
  body: {
    currentDiagnosisType: DiagnosisType
  }
}

type UpdateSmrDiagnosisPayload = RemoveSmrDiagnosisPayload & AddSmrDiagnosisPayload

export const actions = {
  addSmrDiagnosis({ commit }, payload: AddSmrDiagnosisPayload) {
    return Api.request(
      state.requests.addSmrDiagnosis,
      {
        urlParams: payload.urlParams,
        body: payload.body,
        startMut: () => {
          commit('smrStay/startRefreshingGroupingResult', null, { root: true })
        },
        successMut: (response) => {
          commit(
            'smrStay/updateSmrDiagnosisSuccess',
            response,
            { root: true }
          )
          return null
        },
        errorMut: (response) => {
          const badTypeError = `The diagnosis ${payload.body.diagnosis} cannot be set to the given type ${
            payload.body.newDiagnosisType
          }`
          const alreadyCodedError = `The diagnosis ${payload.body.diagnosis} is already coded in another field of this RHS`
          if (response.rawError?.includes(badTypeError)) {
            return { error: `Impossible d\'ajouter le diagnostic au type ${payload.body.newDiagnosisType}` }
          } else if (response.rawError?.includes(alreadyCodedError)) {
            return { error: `Le diagnostic ${payload.body.diagnosis} est déjà codé dans un autre champ de ce RHS` }
          } else {
            return { error: 'Échec de l\'ajout du diagnostic' }
          }
        }
      },
      commit
    )
  },

  removeSmrDiagnosis({ commit }, payload: RemoveSmrDiagnosisPayload) {
    return Api.request(
      state.requests.removeSmrDiagnosis,
      {
        urlParams: payload.urlParams,
        startMut: () => {
          commit('smrStay/startRefreshingGroupingResult', null, { root: true })
        },
        successMut: (response) => {
          commit(
            'smrStay/updateSmrDiagnosisSuccess',
            response,
            { root: true }
          )
          return null
        },
        errorMut: () => {
          return { error: 'Échec de la suppression' }
        }
      },
      commit
    )
  },
  updateSmrDiagnosis({ commit }, payload: UpdateSmrDiagnosisPayload) {
    return Api.request(
      state.requests.updateSmrDiagnosis,
      {
        urlParams: payload.urlParams,
        body: payload.body,
        startMut: () => {
          commit('smrStay/startRefreshingGroupingResult', null, { root: true })
        },
        successMut: (response) => {
          commit(
            'smrStay/updateSmrDiagnosisSuccess',
            response,
            { root: true }
          )
          return null
        },
        errorMut: (response) => {
          const badTypeError = `The diagnosis ${payload.body.diagnosis} cannot be set to the given type ${
            payload.body.newDiagnosisType
          }`
          const alreadyCodedError = `The diagnosis ${payload.body.diagnosis} is already coded in another field of this RHS`
          if (response.rawError?.includes(badTypeError)) {
            return { error: `Impossible d\'ajouter le diagnostic au type ${payload.body.newDiagnosisType}` }
          } else if (response.rawError?.includes(alreadyCodedError)) {
            return { error: `Le diagnostic ${payload.body.diagnosis} est déjà codé dans un autre champ de ce RHS` }
          } else {
            return { error: 'Échec de l\'ajout du diagnostic' }
          }
        }
      },
      commit
    )
  }
}
